import { SelectInput } from "components/FormControls/Select/Select";
import { useMessage } from "hooks/intl";
import { useStyles } from "../../styles";

export const eventsTypes = [
  {
    value: "AchievementCompleted",
    label: "achievementCompleted",
    category: "achievementAdjustment",
  },
  {
    value: "MemberAchievementCompletionCountWasDecreased",
    label: "achievementCompletionCountWasDecreased",
    category: "achievementAdjustment",
  },
  {
    value: "MemberAchievementProgressWasChanged",
    label: "achievementProgressWasChanged",
    category: "achievementAdjustment",
  },
  {
    value: "AssignedCustomEventToCustomer",
    label: "assignedCustomEventToCustomer",
    category: "assignment",
  },
  {
    value: "AssignedTransactionToCustomer",
    label: "assignedTransactionToCustomer",
    category: "assignment",
  },
  {
    value: "CustomAttributeWasAdded",
    label: "customAttributeWasAdded",
    category: "customAttributes",
  },
  {
    value: "CustomAttributesWereDeleted",
    label: "customAttributesWereDeleted",
    category: "customAttributes",
  },
  {
    value: "CustomAttributesWereUpdated",
    label: "customAttributesWereUpdated",
    category: "customAttributes",
  },
  {
    value: "CustomerWasActivated",
    label: "memberWasActivated",
    category: "member",
  },
  {
    value: "CustomerWasAnonymized",
    label: "memberWasAnonymized",
    category: "member",
  },
  {
    value: "CustomerWasDeactivated",
    label: "memberWasDeactivated",
    category: "member",
  },
  {
    value: "CustomerWasRegistered",
    label: "memberWasRegistered",
    category: "member",
  },
  {
    value: "CustomerWasMovedToLevel",
    label: "memberWasMovedToLevel",
    category: "member",
  },
  {
    value: "PendingPointsWereAdded",
    label: "pendingPointsWereAdded",
    category: "units",
  },
  {
    value: "PendingPointsWereCanceled",
    label: "pendingPointsWereCanceled",
    category: "units",
  },
  {
    value: "PointsWereAdded",
    label: "pointsWereAdded",
    category: "units",
  },
  {
    value: "PointsWereBlocked",
    label: "pointsWereBlocked",
    category: "units",
  },
  {
    value: "PointsWereCanceled",
    label: "pointsWereCanceled",
    category: "units",
  },
  {
    value: "PointsWereExpired",
    label: "pointsWereExpired",
    category: "units",
  },
  {
    value: "PointsWereSpent",
    label: "pointsWereSpent",
    category: "units",
  },
  {
    value: "PointsWereTransferred",
    label: "pointsWereTransferred",
    category: "units",
  },
  {
    value: "PointsWereUnblocked",
    label: "pointsWereUnblocked",
    category: "units",
  },
  {
    value: "PointsWereUnlocked",
    label: "pointsWereUnlocked",
    category: "units",
  },
  {
    value: "RewardWasBought",
    label: "rewardWasBought",
    category: "reward",
  },
];

interface Props {
  index: number;
  size: "small" | "medium" | "inline";
  onChange?: () => void;
}

export const Timeline = ({ index, size, onChange }: Props) => {
  const classes = useStyles();
  const { message } = useMessage();
  const isInlineType = size === "inline";

  return (
    <SelectInput
      name={`filters.${index}.value`}
      displaySearch
      displayCategories
      placeholder={message({ id: "value" })}
      data-test-id="filter-value"
      items={eventsTypes.map(({ value, label, category }) => ({
        id: value,
        label: message({ id: label || "" }),
        category: category,
      }))}
      size={isInlineType ? "small" : size}
      multiple
      className={isInlineType ? classes.inlineValue : ""}
      adjustWidthToValue={isInlineType}
      onChange={onChange}
      validateOnChange
    />
  );
};
